import './App.css';
import Home from './Components/Home/home';
import Footer from './Components/Home/section/footer';

function App() {
  return(
    <>
    <Home/>
    <Footer/>
    </>
  );
}

export default App;
